import React, {useEffect, useRef} from 'react';
import {useInView} from 'react-intersection-observer';
import {analytics, eventEmitter} from '../../common/baseData';
import LoadingBlock from '../../components/loadingBlock';

function BrandProductSlider({title, totalTitle, totalLink, children, gaParams, loading = false}) {
  const rootRef = useRef(null);
  const productIdsKey = Array.isArray(gaParams?.productIds) ? gaParams.productIds.join(',') : '';
  const {ref: inViewRef, inView} = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const setRootRef = node => {
    rootRef.current = node;
    inViewRef(node);
  };

  useEffect(() => {
    if (loading || !(rootRef.current instanceof HTMLElement)) return;

    eventEmitter.emit('handleWishlistItems', {
      node: rootRef.current.querySelectorAll('[data-container="favorite"]'),
      range: 'product',
    });
    eventEmitter.emit('handleCompareItems', {
      node: rootRef.current.querySelectorAll('[data-container="compare"]'),
      range: 'product',
    });
  }, [loading]);

  useEffect(() => {
    if (!inView || !productIdsKey) return;

    analytics.viewItemList(
      gaParams.productIds,
      gaParams.item_list_name,
      gaParams.item_list_id,
    )
      .then(response => analytics.view_item_list(response.events[0].params))
      .catch(reason => console.error(reason));
  }, [inView, productIdsKey]);

  return (
    <section className="mt-[20px] w-full min-1024:mt-0" ref={setRootRef}>
      <div className="pb-3 flex items-baseline justify-between">
        <a href={totalLink} className="text-[16px] !font-['OtoiwoGroteskExtended'] leading-normal font-semibold text-black desktop:text-[24px] border-b border-l-0 border-t-0 border-r-0 border-solid border-transparent pb-[2px] hover:border-black">
          {title}
        </a>
        {totalLink && (
          <a href={totalLink}
            className="text-blue-primary text-[16px] leading-normal font-normal border-l-0 border-t-0 border-r-0 border-b border-solid pb-[2px] border-blue-primary">
            {totalTitle}
          </a>
        )}
      </div>
      <ul className="relative min-h-[434px] desktop:px-0 flex overflow-x-scroll scroll-smooth snap-x snap-mandatory overscroll-x-none invisible-scrollbar desktop:min-h-[485px]">
        {loading && (
          <li className="absolute inset-0 z-10 flex list-none items-center justify-center bg-white">
            <LoadingBlock/>
          </li>
        )}
        {!loading && children}
      </ul>
    </section>
  );
}

export default BrandProductSlider;